import LandingHome from './LandingHome';

const Home = () => <LandingHome />

export default Home;
